export default {
    acquiring_device: "Төлемдерді қабылдау құрылғысы",
    add_expense: "Шығындар қосыңыз",
    add_income: "Табыс қосыңыз",
    advance_noun: "Аванс",
    all_pay_methods: "Барлық төлем әдістері",
    bank_terminal: "Банк терминалы",
    cash_operation: "Кассалық операция",
    cashdesk: "Касса",
    cashier: "Кассир",
    cashier_inn: "Кассирдің ЖСН",
    cashier_name: "Кассирдің аты",
    cashless_payment: "Қолма-қол ақшасыз төлем",
    cashless_payments: "Қолма-қол ақшасыз төлемдер",
    cheque: "Чек",
    cheque_generation_in_process_status_might_change_later: "Процесте чекті генерациялау. Статусты өзгерту біраз уақыт алуы мүмкін.",
    cheques: "Чектар",
    close_shift: "Ауысымды жабу",
    closing_balance: "Күннің соңында қалған қалдықтар",
    create_cheque: "Фискалдық чек жасау",
    dashboard: "Бақылау тақтасы",
    data_is_invalid: "Деректер анық емес",
    data_is_valid: "Деректер анық",
    deposit_to_cashdesk: "Кассаға енгізу",
    enter_amount: "Соманы енгізіңіз",
    enter_the_cheque_number: "Чектің нөмірін енгізіңіз",
    error_printing_cheque: "Чекті басып шығаруда қате",
    fiscal_cheque_copy_print: "Қаржылық тексерудің көшірмесі",
    fiscal_cheque_print: "Қаржылық тексеру",
    fiscal_device: "ККТ құрылғысы",
    fiscal_registrar: "Қаржы тіркеушісі",
    fiscal_registrar_management: "Фискалдық тіркеушіні басқару",
    fixed: "Тіркелген",
    injection: "Толтыру",
    issue_an_advance: "Алдын ала беріңіз",
    kkm_url: "Сауда жабдығы серверінің HTTP мекенжайы. ккм сервер локальды емес қосылған жағдайда толтыру.",
    market_as_fiscal_cheque_manually: "Фискалдық чек ретінде қолмен белгілеу",
    name_of_service_in_cheque: "Чектегі қызметтер атауы",
    not_subject_to_vat: "ҚҚС салынбайды",
    only_for_payment_through_terminal: "Тек терминал арқылы төлеу үшін",
    open_shift: "Ауысымды ашу",
    opened_at: "Ашу күні",
    opening_balance: "Күн басындағы қалдық",
    partial_prepayment: "Ішінара алдын ала төлем",
    print_totals: "Қорытындыны басып шығару",
    process_advances_as: "Алдын ала төлем чектерін қалай өткізу керек",
    sale_of_goods: "Тауарларды сату",
    sales: "Сатылымдар",
    send_services_in_cheque: "Чектерді қызметтерді беру",
    shift: "Ауысым",
    shift_number: "Ауысым нөмірі",
    shifts: "Ауысымдар",
    system_to_use: "Жүйені пайдалану",
    terminal: "Терминал",
    totals: "Қорытындылар",
    vat_rate: "ҚҚС ставкасы",
    waiting_for_payment_in_terminal: "Терминалда төлем күтеміз",
    who_accepts_payment: "Төлемді кім қабылдайды",
    withdraw_from_cashdesk: "Кассадан алу",
    withdrawal: "Алу",
    withdrawal_replenishment_from_the_cash_register: "Кассадан шығарылу",
    withdrawal_replenishment_of_cash: "Қолма-қол ақшаны алу / толықтыру",
    xreport: "X-есеп",
    xreports: "X-есептер"
}
